
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/ccpa-privacy-notice",
      function () {
        return require("private-next-pages/severalbrands/ccpa-privacy-notice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/ccpa-privacy-notice"])
      });
    }
  